import { CurrencyPipe } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-calculator',
  imports: [CurrencyPipe],
  templateUrl: './form-calculator.component.html',
  styleUrl: './form-calculator.component.scss',
})
export class FormCalculatorComponent {
  @Input() field;
  @Input() mode;
  @Input() totalAmount;
  @Input() totalInvestment;
  @Input() totalPercent;
  @Input() percentLeft;

  makeNumber(num) {
    if (typeof num === 'number') {
      return num;
    } else {
      const formatted = num.replace('$', '').replaceAll(',', '');
      return +formatted;
    }
  }
}
